// extracted by mini-css-extract-plugin
module.exports = {"team-info":"index_team-info_2UKIy","team-list":"index_team-list_2eZ3b","invite-trigger":"index_invite-trigger_ZLz4Q"};